export default __webpack_public_path__ + "static/media/ornament.21de0780.svg";